import dayjs from 'dayjs';

import { getPickupInfo } from '@/api/order';
import WDateTimeDisplay from '@/components/WDateTimeDisplay/WDateTimeDisplay.vue';
import { SNACKBAR_TYPES } from '@/utils/constants';
import { getWeekString } from '@/utils/helper';

export default {
  name: 'QRCodeDialog',
  props: {
    orders: {
      default: () => [],
      type: Array,
    },
    value: Boolean,
  },
  components: {
    WDateTimeDisplay,
  },
  data() {
    return {
      currentPage: 0,
      qrCodes: {},
    };
  },
  async created() {
    try {
      const func = this.orders.map(({ uuid }) => getPickupInfo(uuid));
      await Promise.allSettled(func).then((results) => {
        results.filter(({ status }) => status !== 'rejected').forEach(({ value: { data = {} } = {} }) => {
          this.qrCodes[data.uuid] = data;
        });
      });
      this.renderQrCode();
    } catch (error) {
      this.$snackbar({
        type: SNACKBAR_TYPES.ERROR,
        title: '無法取得掃碼資料',
        msg: '請稍後再試一次。',
      });
      this.close();
    }
  },
  computed: {
    currentOrder() {
      return this.orders[this.currentPage] || {};
    },
    receiveString() {
      const { receive_time: { start_time: startTime = '' } = {} } = this.currentOrder;
      return `${dayjs(startTime).format('MM/DD')} ${getWeekString(startTime)}`;
    },
  },
  methods: {
    close() {
      this.$emit('input', false);
    },
    getDateTimeText(time = '') {
      return dayjs(time).format('MM/DD HH:mm');
    },
    getOptionItems({ options = [] }) {
      return options.map(({ items = [] }) => items.map(({ name }) => name).join(', ')).join(', ');
    },
    renderQrCode() {
      const encodedData = Buffer.from(JSON.stringify(this.qrCodes[this.currentOrder.uuid])).toString('base64');
      this.$nextTick(() => {
        this.$qrCode.toCanvas(
          document.getElementById('qrCode'),
          encodedData,
          { margin: 2, width: 160 },
        );
      });
    },
  },
  watch: {
    currentPage() {
      this.renderQrCode();
    },
  },
};
